import gsap from 'gsap'
import ScrollTrigger from 'gsap/ScrollTrigger'

export default function() {
  gsap.set('.footer-translate', {
    yPercent: window.innerHeight > 700 ? -50 : -40,
  })

  ScrollTrigger.create({
    trigger: '.footer',
    start: 'top bottom',
    end: 'bottom bottom',
    animation: gsap.to('.footer-translate', { yPercent: 0, ease: 'none' }),
    scrub: true,
  })
}
